import React, { FC, useEffect, useState } from 'react';
import { TFunction } from '@wix/fe-essentials-standalone/i18n';
import { TemplateGalleryCard } from '@common/types';
import { useIntersectionObserver } from 'usehooks-ts';
import TemplateLoadedCard from './TemplateLoadedCard';
import TemplateLoadingCard from './TemplateLoadingCard';
import TemplateCardLinkWrapper from './TemplateCardLinkWrapper';
import { LoadedTemplateCardProps } from './TemplateLoadedCard/TemplateLoadedCard';

export interface TemplateCardProps {
  template: TemplateGalleryCard;
  forceRender?: boolean;
  loader?: boolean;
  index: number;
  t: TFunction;
  onClick: () => void;
  templateHref: string;
  overlayContent?: React.ReactElement;
  CardInfo: LoadedTemplateCardProps['CardInfo'];
  minHeight?: LoadedTemplateCardProps['minHeight'];
  mediaContainerClassName?: LoadedTemplateCardProps['mediaContainerClassName'];
}

const TemplateCard: FC<TemplateCardProps> = ({
  template,
  forceRender,
  loader = false,
  index,
  t,
  onClick,
  templateHref,
  overlayContent,
  minHeight,
  CardInfo,
  mediaContainerClassName,
}) => {
  const [hover, setHover] = useState(false);
  const [focused, setFocused] = useState(false);
  const [ready, setReady] = useState(false || forceRender);
  const { isIntersecting, ref } = useIntersectionObserver({});

  useEffect(() => {
    if (isIntersecting && !ready && !loader) {
      setTimeout(() => {
        setReady(true);
      }, 200);
    }
  }, [ready, isIntersecting]);

  return (
    <TemplateCardLinkWrapper
      template={template}
      templateHref={templateHref}
      onClick={onClick}
      setHover={setHover}
      setFocused={setFocused}
      t={t}
    >
      {ready ? (
        <TemplateLoadedCard
          template={template}
          setHover={setHover}
          hover={hover}
          index={index}
          overlayContent={overlayContent}
          minHeight={minHeight}
          CardInfo={CardInfo}
          mediaContainerClassName={mediaContainerClassName}
        />
      ) : (
        <TemplateLoadingCard ref={ref} />
      )}
    </TemplateCardLinkWrapper>
  );
};

export default TemplateCard;
